import { render } from "./TypeChangeActivityBadge.vue?vue&type=template&id=6f4feae8&scoped=true"
import script from "./TypeChangeActivityBadge.vue?vue&type=script&lang=js"
export * from "./TypeChangeActivityBadge.vue?vue&type=script&lang=js"

import "./TypeChangeActivityBadge.vue?vue&type=style&index=0&id=6f4feae8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f4feae8"

export default script